import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=5cd5d5f7&scoped=true&"
import script from "./Summary.vue?vue&type=script&lang=ts&"
export * from "./Summary.vue?vue&type=script&lang=ts&"
import style0 from "./Summary.vue?vue&type=style&index=0&id=5cd5d5f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd5d5f7",
  null
  
)

export default component.exports